import Model from 'src/storage/base';

class MainModel extends Model {
  id = 'main';
  persistent = true;
  defaultState = () => ({
    tabs: {
      main_treatment: 'treatment',
      main_message: 'chat'
    },
    isOpenBookAppointment: false,
    images: []
  });
  _events = {
    selected_contact: 'onSetContact',
    profile: 'handleProfile',
    show_back: 'onShowBack',
    hide_back: 'onHideBack'
  };

  handleProfile = (profile) => {
    this.setState({ profile, user: profile });
  };

  onSetContact = (contact) => {
    const state = {
      contactUser: contact?.users.find((item) => item.id !== this.getUser()?.id),
      contactId: contact.id
    };
    if (!state.contactUser?.isDoctor) {
      state.isOpenBookAppointment = false;
    }
    this.setState(state);
  };

  onShowBack = (cb) => {
    this.setState({
      showBack: true,
      funcBack: cb
    });
  };

  onHideBack = () => {
    this.setState({
      showBack: false,
      funcBack: null
    });
  };
}

const model = new MainModel();
export default model;
